import Vue from 'vue'
import { camelizeKeys } from 'xcase'
import User from '@/models/user'

export const state = {
  users: [],
}

export const getters = {
  find: state => id => state.users.find(i => i.id == id),
  findByUsername: state => slug => state.users.find(u => u.username == slug),
  sortBy: state => sort => {
    if (sort == 'recent') {
      return [...state.users].sort((a, b) => b.lastActivity.localeCompare(a.lastActivity))
    } else {
      return [...state.users].sort((a, b) => b.likesCount - a.likesCount)
    }
  },
}

export const mutations = {
  ADD(state, data) {
    const index = state.users.findIndex(u => u.id == data.id)

    if (index == -1) {
      state.users.push(new User(data))
    }
  },

  ADD_OR_UPDATE(state, data) {
    const user = state.users.find(i => i.id == data.id)

    if (user) {
      Object.assign(user, camelizeKeys(data))
    } else {
      state.users.push(new User(data))
    }
  },

  APPEND(state, users) {
    users.forEach(user => {
      const index = state.users.findIndex(u => u.id == user.id)

      if (index == -1) state.users.push(new User(user))
    })
  },

  SET(state, users) {
    state.users = users.map(u => new User(u))
  },

  UPDATE(state, data) {
    const user = state.users.find(u => u.id == data.id)

    if (user) {
      Object.assign(user, camelizeKeys(data))
    }
  },

  REMOVE(state, id) {
    const index = state.users.findIndex(u => u.id == id)

    if (index !== -1) {
      state.users.splice(index, 1)
    }
  },
}

export const actions = {
  async fetch({ commit }, { page, sort }) {
    try {
      const response = await Vue.axios.get(`/users?page=${page}&sort=${sort}`)

      if (page == 1) {
        commit('SET', response.data)
      } else {
        commit('APPEND', response.data)
      }

      return response
    } catch (error) {
      console.log(error)
    }
  },

  async fetchSingle({ commit }, username) {
    try {
      const response = await Vue.axios.get(`/users/${username}`)
      commit('ADD', response.data)
    } catch (error) {
      console.log(error)
    }
  },

  async fetchVisitors({ commit }, { page, sort }) {
    try {
      const response = await Vue.axios.get(`/visits/visitors?page=${page}&sort=${sort}`)

      if (page == 1) {
        commit('SET', response.data)
      } else {
        commit('APPEND', response.data)
      }

      return response
    } catch (error) {
      console.log(error)
    }
  },

  async fetchVisited({ commit }, { page, sort }) {
    try {
      const response = await Vue.axios.get(`/visits/visited?page=${page}&sort=${sort}`)

      if (page == 1) {
        commit('SET', response.data)
      } else {
        commit('APPEND', response.data)
      }

      return response
    } catch (error) {
      console.log(error)
    }
  },

  async fetchInterests({ commit }, { username, sort }) {
    try {
      const response = await Vue.axios.get(`/users/${username}/interests?sort=${sort}`)
      commit('interests/SET', response.data, { root: true })
    } catch (error) {
      console.log(error)
    }
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
